import { render, staticRenderFns } from "./SettingVerticalTab.vue?vue&type=template&id=0b6c7eca"
import script from "./SettingVerticalTab.vue?vue&type=script&lang=js"
export * from "./SettingVerticalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports